<template>
    <v-list-item :to="{ name: 'M_Memory' }" :disabled="disabled">
        <v-list-item-icon>
            <v-icon>mdi-brain</v-icon>
        </v-list-item-icon>
        
        <v-list-item-content>
            <v-list-item-title>Memory</v-list-item-title>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
export default {
    name: 'mNavItemSimonSays',
    props: {
        disabled: Boolean,
    }
}
</script>